var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommunications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4H6C4.875 4 4 4.90625 4 6V15C4 16.125 4.875 17 6 17H9V19.625C9 19.9375 9.34375 20.125 9.59375 19.9375L13.5 17H18C19.0938 17 20 16.125 20 15V6C20 4.90625 19.0938 4 18 4Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7980_1509",
    x1: 4.68376,
    y1: 4,
    x2: 21.6999,
    y2: 6.07767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB98D"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunications);
export default __webpack_public_path__ + "static/media/communications.7318d3485c3bd5ff69f184d953dd1ee9.svg";
export { ForwardRef as ReactComponent };